import React, { useMemo, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import projects from '../data/projects';
import ProjectCard from '../components/ProjectCard';
import Footer from '../components/Footer';
import TextReveal from '../components/TextReveal';
import './ProjectsPage.css';

const filters = ['All', 'Winners', '2026', '2025', '2024', '2023'];

const ProjectsPage = () => {
  const [active, setActive] = useState('All');

  const visible = useMemo(() => {
    if (active === 'All') return projects;
    if (active === 'Winners') return projects.filter((p) => p.award);
    return projects.filter((p) => p.year === active);
  }, [active]);

  return (
    <main className="projects-page">
      <div className="projects-page__hero">
        <div className="projects-page__orb" aria-hidden="true" />
        <div className="container">
          <motion.span className="eyebrow" initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            Hackathons & open source
          </motion.span>
          <TextReveal
            as="h1"
            className="projects-page__title"
            text="Everything I've built"
            mode="words"
            delay={0.1}
          />
          <motion.p
            className="projects-page__sub"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.1 }}
          >
            Hardware, AI, and web builds, open-source projects and weekend hackathon prototypes, several of them award winners.
          </motion.p>
        </div>
      </div>

      <div className="container">
        <div className="projects-page__filters">
          {filters.map((f) => (
            <button
              key={f}
              className={`projects-page__filter ${active === f ? 'is-active' : ''}`}
              onClick={() => setActive(f)}
            >
              {active === f && (
                <motion.span
                  className="projects-page__pill"
                  layoutId="filter-pill"
                  transition={{ type: 'spring', stiffness: 380, damping: 32 }}
                />
              )}
              <span className="projects-page__filter-label">{f}</span>
            </button>
          ))}
        </div>

        <motion.div className="projects-page__grid" layout>
          <AnimatePresence mode="popLayout">
            {visible.map((p, i) => (
              <ProjectCard key={p.id} project={p} index={i} />
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      <Footer />
    </main>
  );
};

export default ProjectsPage;
